<template functional>
  <div class="control-radio">
    <label
      tabindex="0"
      class="b-radio radio control-radio"
      :class="$options.bindClass(data)"
    >
      <input
        type="radio"
        v-bind="$options.bindAttrs(data)"
        :ref="props.inputRef"
        :value="props.inputValue"
        :checked="props.inputValue === props.value"
        v-on="$options.bindListeners(listeners)"
        @click="e => $options.setValue(parent, listeners, e)"
      >
      <span class="check"></span>
      <span class="control-label">
        {{ props.label }}
      </span>
    </label>

    <div
      v-if="!!slots().default"
      class="desc is-size-7 has-text-grey"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import Base from './control-base'

export default {
  name: 'ControlRadio',
  mixins: [Base],
  props: {
    label: { type: String, default: () => null },
    inputValue: { type: [String, Number, Boolean], default: () => null },
  },
}
</script>

<style lang="scss">
.control-radio {
  > label {
    font-weight: 500;
  }
  > .desc {
    padding-left: 24px;
  }
}
</style>
